import { unwrapFolderKeyForMember } from './shareLabel';

export async function unwrapSharedFolderKey(
  wrappedFolderKeyBase64: string,
  folderId: string,
  userPrivateKey: Uint8Array,
): Promise<Uint8Array> {
  return unwrapFolderKeyForMember(wrappedFolderKeyBase64, folderId, userPrivateKey);
}
